import { keccak256, toHex } from 'viem'
import { getPostHog } from '../../../instrumentation-client'
import type { IdentifyUserProps } from './types'

export function identifyUser(props: IdentifyUserProps): void {
  const posthog = getPostHog()
  if (!posthog) return
  const { privy_user_id, wallet_address, ...rest } = props
  posthog.identify(privy_user_id, {
    ...rest,
    wallet_address_hash: keccak256(toHex(wallet_address.toLowerCase())).slice(0, 18),
  })
}

export function resetUser(): void {
  const posthog = getPostHog()
  if (!posthog) return
  posthog.reset()
}
